module.exports = "/_next/static/images/310923e0edb745b9a991f824f6ae3827-blog3-lg.png.webp";